"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGAnimatingTextContainer = void 0;
class CTGAnimatingTextContainer extends Phaser.GameObjects.Container {
    constructor(scene, width, text) {
        super(scene);
        this.full_width = width;
        this.text = scene.add.bitmapText(1, 2, 'font', text, 6).setTint(0x0).setOrigin(0).setMaxWidth(width - 1);
        this.full_height = this.text.height + 1;
        this.bg = scene.add.sprite(0, 0, 'pixel').setTint(0xEEEEEE).setDisplaySize(width, this.full_height).setOrigin(0);
        this.shadow = scene.add.sprite(0, 2, 'pixel').setTint(0x0).setDisplaySize(width, 1).setOrigin(0);
        this.maskImg = scene.add.sprite(0, 0, 'pixel').setTint(0x0).setAlpha(1).setDisplaySize(width, 1).setOrigin(0);
        this.maskImg.setVisible(false);
        this.add(this.bg);
        this.add(this.text);
        this.add(this.shadow);
        this.add(this.maskImg);
        this.set_mask_height(0);
    }
    set_mask_height(height) {
        height = Math.floor(height);
        this.yOffset = this.y + (this.parentContainer ? this.parentContainer.y : 0);
        this.maskImg.y = this.yOffset;
        this.maskImg.displayHeight = height + 1;
        this.mask = this.maskImg.createBitmapMask();
        // this.text.height = height;
        this.bg.displayHeight = height;
        this.shadow.y = height;
    }
    animate_height(from, to, delay = 0, callback) {
        // return;
        const tween = this.scene.tweens.addCounter({
            from: from,
            to: to,
            duration: 500,
            delay: delay,
            ease: 'Bounce.easeOut',
            onUpdate: () => {
                this.set_mask_height(tween.getValue());
            },
            onComplete: callback
        });
    }
    animate_in(delay = 0, callback) {
        this.animate_height(0, this.full_height, delay, callback);
    }
    animate_out(delay = 0, callback) {
        this.animate_height(this.full_height, 0, delay, callback);
    }
}
exports.CTGAnimatingTextContainer = CTGAnimatingTextContainer;
